<template>
  <div class="info">
    <lb-table
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    LbTable
  },
  props: {
    userId: Number
  },
  data () {
    return {
      name: 'cdd',
      list: [],
      columns: [
        { label: '收货人姓名', prop: 'name', minWidth: '120' },
        { label: '收货人电话', prop: 'phone', minWidth: '220' },
        { label: '省/市/区', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                {scope.row.provinceName + scope.row.cityName + scope.row.districtName}
              </div>
            )
          }
        },
        { label: '详细地址', prop: 'address', minWidth: '120' },
        { label: '是否为默认地址', minWidth: '120', 
          render: (h, scope) => {
            if(scope.row.isDefault == 1) {
              return (
                <div>默认</div>
              )
            }
            return (
              <div>否</div>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  created () {
    this.getAddressPageList()
  },
  methods: {
    onMultipleSelection(e){},
    handleSizeChange(e){
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getAddressPageList()
    },
    handleCurrentChange(e){
      this.page.pageNo = e;
      this.getAddressPageList()
    },
    getAddressPageList(){
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        userId: this.userId
      }
      this.axios.post('/users/getAddressPageList',data)
      .then(res=>{
        if(res.code == 0){
          this.list = res.data.list;
          this.page.totalNum = res.data.totalNum;
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
/deep/ .el-table .el-table__header .el-table__cell{
    padding: 0;
  }
  /deep/ .el-table .el-table__row .el-table__cell{
    color: #303033;
    font-weight: 400;
  }
</style>

